export const SCOOTER_TRIP_LOADING = "scooter-trip/loading";
export const SCOOTER_TRIP_ERROR = "scooter-trip/error";
export const SCOOTER_TRIP_LIST = "scooter-trip/list";
export const SCOOTER_TRIP_PATH = "scooter-trip/path";
export const SCOOTER_TRIP_UPDATE = "scooter-trip/update";
export const SCOOTER_TRIP_CONTINUE = "scooter-trip/continue";
export const SCOOTER_TRIP_PAUSE = "scooter-trip/pause";
export const SCOOTER_TRIP_SPEED_CHANGE = "scooter-trip/speed-change";
export const SCOOTER_TRIP_SCAN = "scooter-trip/scan";
export const SCOOTER_TRIP_FINISH = "scooter-trip/finish";



// WEBPACK FOOTER //
// ./src/actions/scooter/trip/constants.js